export default __webpack_public_path__ + "static/media/BlogScope.89ef1615.PNG";